module.exports = __webpack_public_path__ + "static/media/joyce.6d6897dc.jpeg";